<form [formGroup]="formGroup" id="step4Form">
  <div class="step4-form-container">
    <div class="row">
      @if (controls.inPolandAtApplicationSubmition; as inPolandAtApplicationSubmition) {
        <div class="standard-form-field radio-form-field inPolandAtApplicationSubmition-field required-field">
          <label
            id="applicantInPolandAtApplicationSubmitionLabel"
            [class.invalid]="inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid">
            {{ 'IN_POLAND_AT_APPLICATION_SUBMITION.INFIELD-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantInPolandAtApplicationSubmitionTooltip'"
              aria-labelledby="applicantInPolandAtApplicationSubmitionLabel"
              class="info-suffix-icon"
              matSuffix
              [text]="'IN_POLAND_AT_APPLICATION_SUBMITION.TOOLTIP' | translate">
            </app-cr-form-field-tooltip>
          </label>
          <mat-radio-group
            id="applicantInPolandAtApplicationSubmition"
            formControlName="inPolandAtApplicationSubmition"
            (keydown)="firstInputKeydown($event)"
            [required]="true"
            [attr.aria-invalid]="
              inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true" id="inPolandAtApplicationSubmition-0">
              {{ 'COMMON.GENERAL.YES' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false" id="inPolandAtApplicationSubmition-1">
              {{ 'COMMON.GENERAL.NO' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.inPolandAtApplicationSubmition.value === true) {
      <div class="row">
        @if (controls.currentlyLivingInPoland; as currentlyLivingInPoland) {
          <div class="standard-form-field radio-form-field currentlyLivingInPoland-field required-field">
            <label
              id="applicantCurrentlyLivingInPolandLabel"
              [class.invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-CURRENTLY-LIVING-IN-POLAND.INFIELD-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="applicantCurrentlyLivingInPoland"
              aria-labelledby="applicantCurrentlyLivingInPolandLabel"
              formControlName="currentlyLivingInPoland"
              (keydown)="firstInputKeydown($event)"
              [attr.aria-invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid ? 'true' : null">
              <mat-radio-button [value]="true" id="applicantCurrentlyLivingInPoland-0">
                {{ 'COMMON.GENERAL.YES' | translate }}
              </mat-radio-button>
              <mat-radio-button [value]="false" id="applicantCurrentlyLivingInPoland-1">
                {{ 'COMMON.GENERAL.NO' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        }
      </div>
    }
    @if (
      controls.inPolandAtApplicationSubmition.value === true &&
      (controls.currentlyLivingInPoland.value === true || controls.currentlyLivingInPoland.value === false)
    ) {
      <div class="row">
        @if (controls.legalBasisOfStay; as legalBasisOfStay) {
          <div class="standard-form-field widened-field legalBasisOfStay-field required-field">
            <label
              id="applicantLegalBasisOfStayLabel"
              [class.invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid">
              {{
                controls.currentlyLivingInPoland.value === true
                  ? ('PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
                  : ('PERSONAL_DATA_FORM.PLANNED-LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
              }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantLegalBasisOfStay"
                panelClass="standard-select"
                placeholder="{{
                  controls.currentlyLivingInPoland.value === true
                    ? ('PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY.PLACEHOLDER' | translate)
                    : ('PERSONAL_DATA_FORM.PLANNED-LEGAL-BASIS-OF-STAY.PLACEHOLDER' | translate)
                }}"
                formControlName="legalBasisOfStay"
                [attr.aria-required]="true"
                [attr.aria-labelledby]="'applicantLegalBasisOfStayLabel'"
                [attr.aria-invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'legalBasisOfStayError' : null
                ">
                @for (item of legalBasisOfStayList.longResi; track item) {
                  <mat-option [value]="item.value">
                    {{ 'SELECTS_VALUES.STAY_LEGAL_BASIS_NEW.' + item.labelKey | translate }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (legalBasisOfStay.touched && legalBasisOfStay.invalid) {
                <mat-error id="legalBasisOfStayError">
                  {{ legalBasisOfStay.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (controls.residenceVisaExpiryDate; as residenceVisaExpiryDate) {
          <div class="standard-form-field residenceVisaExpiryDate-field required-field">
            <label
              for="applicantResidenceVisaExpiryDatePickerNoCurrentlyInRP"
              [class.invalid]="
                (residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid) ||
                formGroup.errors?.visaExpiredBeforeLastEntryDate
              ">
              {{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="residenceVisaExpiryDatePicker.open()">
              <input
                matInput
                id="applicantResidenceVisaExpiryDatePickerNoCurrentlyInRP"
                #applicantResidenceVisaExpiryDatePicker
                readonly
                (focus)="residenceVisaExpiryDatePicker.open()"
                [matDatepicker]="residenceVisaExpiryDatePicker"
                [min]="currentDate"
                [max]="maxValidDocumentExpiryDate"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.PLACEHOLDER' | translate }}"
                formControlName="residenceVisaExpiryDate"
                [attr.aria-required]="true"
                [attr.aria-invalid]="residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid
                    ? 'residenceVisaExpiryDateError'
                    : null
                " />
              <mat-datepicker-toggle
                matSuffix
                [for]="residenceVisaExpiryDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>
              <mat-datepicker
                #residenceVisaExpiryDatePicker
                [startView]="'month'"
                [startAt]="residenceVisaExpiryDate.value || documentExpiryPickerStartDate"
                (closed)="applicantResidenceVisaExpiryDatePicker.blur()">
              </mat-datepicker>
              <!-- ERROR -->
              @if (residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid) {
                <mat-error id="residenceVisaExpiryDateError">
                  {{ residenceVisaExpiryDate.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <div class="row">
        @if (controls.lastEntryDate; as lastEntryDate) {
          <div class="standard-form-field lastEntryDate-field required-field">
            <label for="applicantLastEntryDate" [class.invalid]="lastEntryDate.touched && lastEntryDate.invalid">
              {{
                controls.currentlyLivingInPoland.value === true
                  ? ('PERSONAL_DATA_FORM.LAST-ENTRY-DATE.MAIN-LABEL' | translate)
                  : ('PERSONAL_DATA_FORM.PLANNED-ENTRY-DATE.MAIN-LABEL' | translate)
              }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline" (click)="lastEntryDatePicker.open()">
              <input
                matInput
                id="applicantLastEntryDate"
                #applicantLastEntryDate
                readonly
                (focus)="lastEntryDatePicker.open()"
                [matDatepicker]="lastEntryDatePicker"
                placeholder="{{ 'PERSONAL_DATA_FORM.LAST-ENTRY-DATE.PLACEHOLDER' | translate }}"
                [min]="controls.currentlyLivingInPoland.value === true ? null : currentDate"
                [max]="controls.currentlyLivingInPoland.value === true ? currentDate : null"
                formControlName="lastEntryDate"
                [attr.aria-required]="true"
                [attr.aria-invalid]="lastEntryDate.touched && lastEntryDate.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  lastEntryDate.touched && lastEntryDate.invalid ? 'lastEntryDateEntry' : null
                " />
              <mat-datepicker-toggle
                matSuffix
                [for]="lastEntryDatePicker"
                aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
              </mat-datepicker-toggle>
              <mat-datepicker
                #lastEntryDatePicker
                [startAt]="currentDate"
                [startView]="'month'"
                (closed)="applicantLastEntryDate.blur()">
              </mat-datepicker>
              <!-- ERROR -->
              @if (lastEntryDate.touched && lastEntryDate.invalid) {
                <mat-error id="lastEntryDateEntry">
                  {{ lastEntryDate.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
            <!-- ERROR -->
            @if (formGroup.errors?.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE) {
              <mat-error>
                {{ 'COMMON.VALIDATOR.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE' | translate }}
              </mat-error>
            }
          </div>
        }
        @if (controls.purposeOfStay; as purposeOfStay) {
          <div class="standard-form-field widened-field purposeOfStay-field required-field">
            <label for="purposeOfStayInput" [class.invalid]="purposeOfStay.touched && purposeOfStay.invalid">
              {{ 'PERSONAL_DATA_FORM.PURPOSE-OF-STAY.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="purposeOfStayInput"
                panelClass="standard-select"
                placeholder="{{ 'PERSONAL_DATA_FORM.PURPOSE-OF-STAY.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="purposeOfStay.touched && purposeOfStay.invalid ? 'true' : null"
                [attr.aria-describedby]="purposeOfStay.touched && purposeOfStay.invalid ? 'purposeOfStayError' : null"
                formControlName="purposeOfStay">
                @for (item of purposeOfStayList; track item) {
                  <mat-option [value]="item">
                    {{ 'PROCESSES.ORIG_PROCESSES.' + item | translate }}
                  </mat-option>
                }
              </mat-select>
              <!-- ERROR -->
              @if (purposeOfStay.touched && purposeOfStay.invalid) {
                <mat-error id="purposeOfStayError">
                  {{ purposeOfStay.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      @if (showStayVisaFields) {
        <app-partial-stay-visa
          [controls]="controls"
          [minValidDate]="minValidDate"
          [maxValidDate]="maxValidDate"
          [maxValidFutureDate]="maxValidFutureDate"
          [documentIssuePickerStartDate]="documentIssuePickerStartDate"
          [documentExpiryPickerStartDate]="documentExpiryPickerStartDate"
          [visaTypes]="visaTypes">
        </app-partial-stay-visa>
      }
      @if (showEntitlingDocumentFields) {
        <app-partial-entitling-document
          [controls]="controls"
          [minValidDate]="minValidDate"
          [maxValidDate]="maxValidDate"
          [documentIssuePickerStartDate]="documentIssuePickerStartDate">
        </app-partial-entitling-document>
      }
      @if (showEntryDocumentFields) {
        <app-partial-entry-document
          [controls]="controls"
          [minValidDate]="minValidDate"
          [maxValidDate]="maxValidDate"
          [maxValidFutureDate]="maxValidFutureDate"
          [documentIssuePickerStartDate]="documentIssuePickerStartDate"
          [documentExpiryPickerStartDate]="documentExpiryPickerStartDate">
        </app-partial-entry-document>
      }
    }

    <nz-divider [nzText]="staysInPoland" nzOrientation="center">
      <ng-template #staysInPoland>
        <h5>{{ 'PERSONAL_DATA_FORM.STAYS_IN_POLAND' | translate }}</h5>
      </ng-template>
    </nz-divider>

    <div class="row">
      @if (controls.noPreviousVisits; as noPreviousVisits) {
        <div class="standard-form-field radio-form-field noPreviousVisits-field required-field">
          <label id="noPreviousVisitsLabel" [class.invalid]="noPreviousVisits.touched && noPreviousVisits.invalid">
            {{ 'PERSONAL_DATA_FORM.NO-PREVIOUS-VISITS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="noPreviousVisits"
            aria-labelledby="noPreviousVisitsLabel"
            formControlName="noPreviousVisits"
            [required]="true"
            [attr.aria-invalid]="noPreviousVisits.touched && noPreviousVisits.invalid ? 'true' : null">
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
    @if (controls.noPreviousVisits.value === false) {
      <div class="row visits-row">
        @if (controls.previousVisitsArr; as previousVisitsArr) {
          <div class="standard-form-field widened-field required-field">
            <label [class.invalid]="previousVisitsArr.touched && previousVisitsArr.invalid">
              {{ 'PERSONAL_DATA_FORM.PLEASE_LIST_ALL_YOUR_STAYS' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
          </div>
        }
        <app-previous-visits-form-long-resi
          [previousVisitsArrFc]="controls.previousVisitsArr"
          [disabled]="controls.previousVisitsArr.disabled"
          [inPolandAtApplicationSubmition]="controls.inPolandAtApplicationSubmition"
          [lastEntryDateFc]="controls.lastEntryDate"
          [legalBasisOfStayFc]="controls.legalBasisOfStay"
          [legalBasisOfStayCommentFc]="controls.legalBasisOfStayComment"
          [currentlyLivingInPolandFc]="controls.currentlyLivingInPoland">
        </app-previous-visits-form-long-resi>
      </div>
    }

    <div class="row">
      @if (controls.noLastTravelsOutsidePoland; as noLastTravelsOutsidePoland) {
        <div class="standard-form-field radio-form-field noLastTravelsOutsidePoland-field required-field">
          <label
            id="noLastTravelsOutsidePolandLabel"
            [class.invalid]="noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid">
            {{ 'PERSONAL_DATA_FORM.LAST-TRAVELS-OUTSIDE-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <!-- IMPORTANT about noLastTravelsOutsidePoland
                                        there is fuckup because of different label text!
                                        the field is 'noLastTravelsOutsidePoland' so it would mean that
                                        if noLastTravelsOutsidePoland === true then user DID NOT have any travels outside poland.
                                        BUT! !IMPORTANT! current label for this field is: 'Czy przekraczałeś granice krajów innych niż Polska w przeciągu ostatnich 5 lat?'
                                        so if user marks YES then it means that we have to set our field value to `false` as user DID HAVE TRAVELS OUTSIDE POLAND
                                        -->
          <mat-radio-group
            id="noLastTravelsOutsidePoland"
            aria-labelledby="noLastTravelsOutsidePolandLabel"
            formControlName="noLastTravelsOutsidePoland"
            [required]="true"
            [attr.aria-invalid]="
              noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.noLastTravelsOutsidePoland.value === false && visitsAmount > 1 && mode === 'employee') {
        <cr-button
          class="sort-button"
          [isLoading]="isVisitsSorting"
          [isDisabled]="isVisitsLoading"
          (clicked)="sortClick$.next()">
          {{ 'COUNTRIES_VISITS_FORM.SORT_VISITS' | translate }}
        </cr-button>
      }
    </div>

    @if (controls.noLastTravelsOutsidePoland.value === false) {
      <div class="row visits-row">
        @if (controls.lastTravelsOutsidePoland; as lastTravelsOutsidePoland) {
          <div class="standard-form-field widened-field required-field">
            <label [class.invalid]="lastTravelsOutsidePoland.touched && lastTravelsOutsidePoland.invalid">
              {{ 'PERSONAL_DATA_FORM.PLEASE_LIST_ALL_YOUR_TRAVELS' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
          </div>
        }
        <app-countries-visits-form-long-resi
          [lastTravelsOutsidePoland]="controls.lastTravelsOutsidePoland"
          [disabled]="controls.lastTravelsOutsidePoland.disabled"
          [triggerSort]="sortClick$"
          (sortingChanged)="onVisitsSortingChange($event)"
          (loadingChanged)="onVisitsLoadingChange($event)">
        </app-countries-visits-form-long-resi>
      </div>
    }

    <div class="row">
      @if (controls.hasBlueCardStaysInEU; as hasBlueCardStaysInEU) {
        <div class="standard-form-field radio-form-field hasBlueCardStaysInEU-field required-field">
          <label
            id="hasBlueCardStaysInEULabel"
            [class.invalid]="hasBlueCardStaysInEU.touched && hasBlueCardStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-BLUE-CARD-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasBlueCardStaysInEU"
            aria-labelledby="hasBlueCardStaysInEULabel"
            formControlName="hasBlueCardStaysInEU"
            [required]="true"
            [attr.aria-invalid]="hasBlueCardStaysInEU.touched && hasBlueCardStaysInEU.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasBlueCardStaysInEU.value === true) {
      <div class="row">
        @if (controls.blueCardStaysInEU; as blueCardStaysInEU) {
          <div class="standard-form-field three-fourth-field blueCardStaysInEU-field radio-form-field required-field">
            <label
              for="blueCardStaysInEUInput"
              [class.invalid]="blueCardStaysInEU.touched && blueCardStaysInEU.invalid">
              {{ 'PERSONAL_DATA_FORM.HAVE-BLUE-CARD-STAYS-IN-EU.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="blueCardStaysInEUInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="blueCardStaysInEU"
                [attr.aria-required]="true"
                [attr.aria-invalid]="blueCardStaysInEU.touched && blueCardStaysInEU.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  blueCardStaysInEU.touched && blueCardStaysInEU.invalid ? 'blueCardStaysInEUError' : null
                "></textarea>
              <!-- ERROR -->
              @if (blueCardStaysInEU.touched && blueCardStaysInEU.invalid) {
                <mat-error id="blueCardStaysInEUError">
                  {{ blueCardStaysInEU.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div class="row">
      @if (controls.hasScientistStaysInEU; as hasScientistStaysInEU) {
        <div class="standard-form-field radio-form-field hasScientistStaysInEU-field required-field">
          <label
            id="hasScientistStaysInEULabel"
            [class.invalid]="hasScientistStaysInEU.touched && hasScientistStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-SCIENTIST-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasScientistStaysInEU"
            aria-labelledby="hasScientistStaysInEULabel"
            formControlName="hasScientistStaysInEU"
            [required]="true"
            [attr.aria-invalid]="hasScientistStaysInEU.touched && hasScientistStaysInEU.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasScientistStaysInEU.value === true) {
      <div class="row">
        @if (controls.scientistStaysInEU; as scientistStaysInEU) {
          <div class="standard-form-field three-fourth-field scientistStaysInEU-field radio-form-field required-field">
            <label
              for="scientistStaysInEUInput"
              [class.invalid]="scientistStaysInEU.touched && scientistStaysInEU.invalid">
              {{ 'PERSONAL_DATA_FORM.HAVE-SCIENTIST-STAYS-IN-EU.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="scientistStaysInEUInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="scientistStaysInEU"
                [attr.aria-required]="true"
                [attr.aria-invalid]="scientistStaysInEU.touched && scientistStaysInEU.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  scientistStaysInEU.touched && scientistStaysInEU.invalid ? 'scientistStaysInEUError' : null
                "></textarea>
              <!-- ERROR -->
              @if (scientistStaysInEU.touched && scientistStaysInEU.invalid) {
                <mat-error id="scientistStaysInEUError">
                  {{ scientistStaysInEU.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div class="row">
      @if (controls.hasInternationalProtectionStaysInEU; as hasInternationalProtectionStaysInEU) {
        <div class="standard-form-field radio-form-field hasInternationalProtectionStaysInEU-field required-field">
          <label
            id="hasInternationalProtectionStaysInEULabel"
            [class.invalid]="
              hasInternationalProtectionStaysInEU.touched && hasInternationalProtectionStaysInEU.invalid
            ">
            {{ 'PERSONAL_DATA_FORM.HAVE-INTERNATIONAL-PROTECTION-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasInternationalProtectionStaysInEU"
            aria-labelledby="hasInternationalProtectionStaysInEULabel"
            formControlName="hasInternationalProtectionStaysInEU"
            [required]="true"
            [attr.aria-invalid]="
              hasInternationalProtectionStaysInEU.touched && hasInternationalProtectionStaysInEU.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasInternationalProtectionStaysInEU.value === true) {
      <div class="row">
        @if (controls.internationalProtectionStaysInEU; as internationalProtectionStaysInEU) {
          <div
            class="standard-form-field three-fourth-field internationalProtectionStaysInEU-field radio-form-field required-field">
            <label
              for="internationalProtectionStaysInEUInput"
              [class.invalid]="internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid">
              {{ 'PERSONAL_DATA_FORM.HAVE-INTERNATIONAL-PROTECTION-STAYS-IN-EU.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="internationalProtectionStaysInEUInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="internationalProtectionStaysInEU"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid
                    ? 'internationalProtectionStaysInEUError'
                    : null
                "></textarea>
              <!-- ERROR -->
              @if (internationalProtectionStaysInEU.touched && internationalProtectionStaysInEU.invalid) {
                <mat-error id="internationalProtectionStaysInEUError">
                  {{ internationalProtectionStaysInEU.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div class="row">
      @if (controls.hasHighQualificationsStaysInEU; as hasHighQualificationsStaysInEU) {
        <div class="standard-form-field radio-form-field hasHighQualificationsStaysInEU-field required-field">
          <label
            id="hasHighQualificationsStaysInEULabel"
            [class.invalid]="hasHighQualificationsStaysInEU.touched && hasHighQualificationsStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-HIGH-QUALIFICATIONS-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasHighQualificationsStaysInEU"
            aria-labelledby="hasHighQualificationsStaysInEULabel"
            formControlName="hasHighQualificationsStaysInEU"
            [required]="true"
            [attr.aria-invalid]="
              hasHighQualificationsStaysInEU.touched && hasHighQualificationsStaysInEU.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasHighQualificationsStaysInEU.value === true) {
      <div class="row">
        @if (controls.highQualificationsStaysInEU; as highQualificationsStaysInEU) {
          <div
            class="standard-form-field three-fourth-field highQualificationsStaysInEU-field radio-form-field required-field">
            <label
              for="highQualificationsStaysInEUInput"
              [class.invalid]="highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid">
              {{ 'PERSONAL_DATA_FORM.HAVE-HIGH-QUALIFICATIONS-STAYS-IN-EU.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="highQualificationsStaysInEUInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="highQualificationsStaysInEU"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid
                    ? 'highQualificationsStaysInEUError'
                    : null
                "></textarea>
              <!-- ERROR -->
              @if (highQualificationsStaysInEU.touched && highQualificationsStaysInEU.invalid) {
                <mat-error id="highQualificationsStaysInEUError">
                  {{ highQualificationsStaysInEU.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div class="row">
      @if (controls.hasStudentStaysInEU; as hasStudentStaysInEU) {
        <div class="standard-form-field radio-form-field hasStudentStaysInEU-field required-field">
          <label
            id="hasStudentStaysInEULabel"
            [class.invalid]="hasStudentStaysInEU.touched && hasStudentStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-STUDENT-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasStudentStaysInEU"
            aria-labelledby="hasStudentStaysInEULabel"
            formControlName="hasStudentStaysInEU"
            [required]="true"
            [attr.aria-invalid]="hasStudentStaysInEU.touched && hasStudentStaysInEU.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasStudentStaysInEU.value === true) {
      <div class="row">
        @if (controls.studentStaysInEU; as studentStaysInEU) {
          <div class="standard-form-field three-fourth-field studentStaysInEU-field radio-form-field required-field">
            <label for="studentStaysInEUInput" [class.invalid]="studentStaysInEU.touched && studentStaysInEU.invalid">
              {{ 'PERSONAL_DATA_FORM.HAVE-STUDENT-STAYS-IN-EU.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="studentStaysInEUInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="studentStaysInEU"
                [attr.aria-required]="true"
                [attr.aria-invalid]="studentStaysInEU.touched && studentStaysInEU.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  studentStaysInEU.touched && studentStaysInEU.invalid ? 'studentStaysInEUError' : null
                "></textarea>
              <!-- ERROR -->
              @if (studentStaysInEU.touched && studentStaysInEU.invalid) {
                <mat-error id="studentStaysInEUError">
                  {{ studentStaysInEU.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div class="row">
      @if (controls.hasTravelsWithBlueCardStaysInEU; as hasTravelsWithBlueCardStaysInEU) {
        <div class="standard-form-field radio-form-field hasTravelsWithBlueCardStaysInEU-field required-field">
          <label
            id="hasTravelsWithBlueCardStaysInEULabel"
            [class.invalid]="hasTravelsWithBlueCardStaysInEU.touched && hasTravelsWithBlueCardStaysInEU.invalid">
            {{ 'PERSONAL_DATA_FORM.HAVE-TRAVELS-WITH-BLUE-CARD-STAYS-IN-EU-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasTravelsWithBlueCardStaysInEU"
            aria-labelledby="hasTravelsWithBlueCardStaysInEULabel"
            formControlName="hasTravelsWithBlueCardStaysInEU"
            [required]="true"
            [attr.aria-invalid]="
              hasTravelsWithBlueCardStaysInEU.touched && hasTravelsWithBlueCardStaysInEU.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasTravelsWithBlueCardStaysInEU.value === true) {
      <div class="row">
        @if (controls.travelsWithBlueCardStaysInEU; as travelsWithBlueCardStaysInEU) {
          <div
            class="standard-form-field three-fourth-field travelsWithBlueCardStaysInEU-field radio-form-field required-field">
            <label
              for="travelsWithBlueCardStaysInEUInput"
              [class.invalid]="travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid">
              {{ 'PERSONAL_DATA_FORM.HAVE-TRAVELS-WITH-BLUE-CARD-STAYS-IN-EU.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="travelsWithBlueCardStaysInEUInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="travelsWithBlueCardStaysInEU"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid
                    ? 'travelsWithBlueCardStaysInEUError'
                    : null
                "></textarea>
              <!-- ERROR -->
              @if (travelsWithBlueCardStaysInEU.touched && travelsWithBlueCardStaysInEU.invalid) {
                <mat-error id="travelsWithBlueCardStaysInEUError">
                  {{ travelsWithBlueCardStaysInEU.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div class="row">
      @if (controls.hasOtherLongTermPermits; as hasOtherLongTermPermits) {
        <div class="standard-form-field radio-form-field hasOtherLongTermPermits-field required-field">
          <label
            id="hasOtherLongTermPermitsLabel"
            [class.invalid]="hasOtherLongTermPermits.touched && hasOtherLongTermPermits.invalid">
            {{ 'PERSONAL_DATA_FORM.OTHER-LONG-TERM-PERMITS-BOOLEAN.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="hasOtherLongTermPermits"
            aria-labelledby="hasOtherLongTermPermitsLabel"
            formControlName="hasOtherLongTermPermits"
            (keydown.Tab)="
              controls.hasOtherLongTermPermits.value === true ? undefined : emitLastFieldTabPressed($event)
            "
            [required]="true"
            [attr.aria-invalid]="hasOtherLongTermPermits.touched && hasOtherLongTermPermits.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>

    @if (controls.hasOtherLongTermPermits.value === true) {
      <div class="row">
        @if (controls.otherLongTermPermits; as otherLongTermPermits) {
          <div
            class="standard-form-field three-fourth-field otherLongTermPermits-field radio-form-field required-field">
            <label
              for="otherLongTermPermitsInput"
              [class.invalid]="otherLongTermPermits.touched && otherLongTermPermits.invalid">
              {{ 'PERSONAL_DATA_FORM.OTHER-LONG-TERM-PERMITS.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="6"
                id="otherLongTermPermitsInput"
                type="text"
                minLength="1"
                maxLength="9999"
                placeholder=""
                [formControl]="otherLongTermPermits"
                [attr.aria-required]="true"
                [attr.aria-invalid]="otherLongTermPermits.touched && otherLongTermPermits.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  otherLongTermPermits.touched && otherLongTermPermits.invalid ? 'otherLongTermPermitsError' : null
                "
                (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()">
              </textarea>
              <!-- ERROR -->
              @if (otherLongTermPermits.touched && otherLongTermPermits.invalid) {
                <mat-error id="otherLongTermPermitsError">
                  {{ otherLongTermPermits.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
  </div>
</form>
